import Vue from 'vue'
import Child from './Child'

// Base

import Spinner from './spinner/Spinner'
import Page from './Page'

// Front

import Banner from './front/Banner'
import Banners from './front/Banners'
import Card from './front/Card'
import Carousel from './front/Carousel'
import Image from './front/Image'
import Row from './front/Row'
import RowGroup from './front/RowGroup'
import Tabs from './front/Tabs'
import Title from './front/Title'
import BannerButton from './front/BannerButton'

// Components that are registered globaly.
[
    Spinner,
    Page,
    Child,
    Banner,
    Banners,
    Card,
    Carousel,
    Image,
    Row,
    RowGroup,
    Tabs,
    Title,
    BannerButton
].forEach(Component => {
    Vue.component(Component.name, Component)
})



// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js